// extracted by css-extract-rspack-plugin
export default {"settlementQuotaConfig":"settlementQuotaConfig-natbn7","leftMenu":"leftMenu-ontYtA","rightTable":"rightTable-lYXgsm","rightTableTop":"rightTableTop-y24os9"};